module.exports = __webpack_public_path__ + "img/violet_145.cc09e850.png";